import React, { useEffect, useState } from "react";
import BlogCard from "../components/layouts/Blog/BlogCard";
import BlogCat from "../components/layouts/Blog/BlogCat";
import BlogFilter from "../components/layouts/Blog/BlogFilter";
import BlogLatest from "../components/layouts/Blog/BlogLatest";
import BlogTag from "../components/layouts/Blog/BlogTag";
import BlogCatFilter from "../components/layouts/Blog/FilterBlogModal/BlogCatFilter";
import BlogTimeFilter from "../components/layouts/Blog/FilterBlogModal/BlogTimeFilter";
import PersianPagination from "../components/shared/Paginatio";
import useFetch from "../hooks/useAxios";

const Blog = () => {
  const [BLogInfo, setBLogInfo] = useState([]);
  const [blogTimeFilterState, setBlogTimeFilterState] = useState([{name:"newest"}]);
  const [blogpopularFilter, setBlogpopularFilter] = useState();
  const [blogcategoryFilter, setBlogcategoryFilter] = useState([]);


  const [CatModal, setCatModal] = useState(false);
  const [TimeModal, setTimeModal] = useState(false);
  const [totalPage, setTotlaPage] = useState() 
  const [currentPage, setCurrentPage] = useState(1) 
  const apiGetBlog = useFetch({
    method: "get",
    url: "api/posts",
    noHeader: true,
    trigger: true,
    params:{
      time:blogTimeFilterState.length > 0 ? blogTimeFilterState[0].name : null,
      category:blogcategoryFilter.length>0 ? blogcategoryFilter.map(i => i.name).toString().replace(/,/g, "-"):null,
      page:currentPage


  },
    argFunc: res =>{ setBLogInfo(res.data.posts);setTotlaPage(res.data.total_posts)},
   
  });
  useEffect(() => {
   if(currentPage > 1){
    apiGetBlog.reFetch()
   }
  }, [currentPage])
  
  return (
    <div className="container">
      <div className="Blog-grid mt-[40px]">
        <div className="">
          <BlogCat />
          <BlogTag />
          <BlogLatest BLogInfo={BLogInfo} />
        </div>
        <div>
          <BlogFilter setTimeModal={setTimeModal} setCatModal={setCatModal} />
          <div className="BlogCard-container">
            {!apiGetBlog.loading
              ? BLogInfo.map(i => <BlogCard key={i.id} info={i} />)
              : null}
              
          </div>
          <PersianPagination  total={totalPage} pageSize={20}  setcurrentPage={setCurrentPage}/>
        </div>
        {CatModal &&
          <BlogCatFilter
          apiGetBlog={apiGetBlog}
            closeModal={() => setCatModal(false)}
            BlogCat={blogcategoryFilter}
            setBlogCat={setBlogcategoryFilter}
          />}
           {TimeModal &&
          <BlogTimeFilter
          apiGetBlog={apiGetBlog}
            closeModal={() => setTimeModal(false)}
            BlogTime={blogTimeFilterState}
            setBlogTime={setBlogTimeFilterState}
          />}
      </div>
    </div>
  );
};

export default Blog;
